"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var antd_1 = require("antd");
var hooks_1 = require("../../hooks");
var actions_1 = require("../../modules/categories/actions");
var hooks_2 = require("../../modules/categories/hooks");
var utils_1 = require("../../utils");
var CategoryForm_1 = __importDefault(require("./CategoryForm"));
var CategoryEditView = (0, react_1.memo)(function () {
    var dispatch = (0, hooks_1.useAppDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var categoryID = (0, react_router_dom_1.useParams)().id;
    var getAccessTokenSilently = (0, auth0_react_1.useAuth0)().getAccessTokenSilently;
    var _a = (0, hooks_2.useCategories)(), categories = _a.items, isFetching = _a.isFetching, isUpdating = _a.isUpdating;
    var category = (0, react_1.useMemo)(function () { return (0, utils_1.findItemByID)(categories, categoryID); }, [categories, categoryID]);
    var onFinish = (0, react_1.useCallback)(function (v) { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("saving category", v);
                    return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE)];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, dispatch((0, actions_1.updateCategory)(category.id, v, accessToken))];
                case 2:
                    result = _a.sent();
                    if (!result.error) {
                        antd_1.message.success("Saved changes to category: ".concat(result.data.id));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently, dispatch, category]);
    var onBack = (0, react_1.useCallback)(function () { return navigate(-1); }, [navigate]);
    return react_1.default.createElement(antd_1.PageHeader, { onBack: onBack, ghost: false, title: isFetching ? "Loading..." : (category ? "Edit Category: ".concat(category.id) : "Category not found"), subTitle: category ? "Press submit to save your changes." : "" }, category && react_1.default.createElement(CategoryForm_1.default, { initialValues: category, onFinish: onFinish, loading: isUpdating }));
});
exports.default = CategoryEditView;
